import { Box, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Table from '../../components/Table/Table';
import TablePagination from '../../components/TablePagination/TablePagination';
import { Sort } from '../../models/CommonModels';
import CompaniesTableFilters, { CompanyFilter } from './CompaniesTableFilters';
import useCompaniesTable from './useCompaniesTable';

function CompaniesTable() {
  const [t] = useTranslation();
  const [activePage, setActivePage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filter, setFilter] = useState<CompanyFilter>({ filter: '' });
  const [sort, setSort] = useState<Sort>({ order: 'asc', orderBy: 'name' });
  const { headers, rows, totalCompanies, isLoading } = useCompaniesTable(activePage, pageSize, filter, sort);

  /**
   * On pagination change
   * Perform a new request
   * @param page
   * @param pSize
   */
  const handlePaginationChange = (page: number, pSize: number) => {
    setActivePage(page);
    setPageSize(pSize);
  };

  /**
   * On search click
   * @param companyFilter
   */
  const handleSearch = (companyFilter: CompanyFilter) => {
    setActivePage(1);
    setFilter(companyFilter);
  };

  /**
   * Handle change of the table sort
   * @param s
   */
  const handleOnSort = (s: Sort) => {
    setSort(s);
  };

  return (
    <Box paddingBottom="3rem">
      <CompaniesTableFilters onSearch={handleSearch} isLoading={isLoading} />
      <Typography variant="body1" paddingBottom="1rem">
        {t('common.table.totalItems', { count: totalCompanies })}
      </Typography>
      <Table headers={headers} rows={rows} isLoading={isLoading} defaultOrderBy={sort.orderBy} onSort={handleOnSort} />
      <TablePagination
        activePage={activePage}
        pageSize={pageSize}
        totalItems={totalCompanies}
        handlePageChange={handlePaginationChange}
      />
    </Box>
  );
}

export default CompaniesTable;
